import React from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../Components/BackButton";
import NewAddressForm from "../Forms/NewAddressForm";
import { useDispatch, useSelector } from "react-redux";
import { updateRegistrant } from "../store/registrant/registrantSlice";
import { changeStep } from "../store/settings/settingsSlice";
import { getContent } from "../content";

function NewAddress() {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const registrant = useSelector((state) => state.registrant);

    React.useEffect(() => {
        dispatch(changeStep([4, 6]));
    }, []);

    const onSubmit = (data) => {
        Object.keys(data).forEach(key => data[key] === undefined ? delete data[key] : {});

        dispatch(updateRegistrant({
            ...data
        }));

        navigate('/has-mailing-address');
    };

    return (
        <section className="flex flex-col gap-4">
            <div className="">
                <BackButton onClick={() => navigate(-1)} />
                <h2 className="my-4 md:my-8 lg:mt-16">{getContent('new_address.heading')}</h2>
            </div>
            <div className="">
                <div className="border-4 border-evcpa-darkpurple rounded-lg p-8">
                    <NewAddressForm submit={onSubmit} />
                </div>
            </div>
        </section>
    );
}

export default NewAddress;